import React from "react";
import { Badge } from "react-bootstrap";

/**
 * L'effort qu'une commande demande sur place, pour choisir son livreur : du
 * pied du camion au 2e étage sans ascenseur. Tout vient du serveur
 * (`estimation_manutention`, EstimationManutentionService) : niveau, libellé,
 * détails et temps prévu ne sont pas recalculés ici.
 */

const STYLES = {
  pied_camion: { bg: "secondary", court: "Pied du camion" },
  plain_pied: { bg: "info", text: "dark", court: "Plain-pied" },
  ascenseur: { bg: "info", text: "dark", court: "Étage avec asc." },
  etage_1: { bg: "warning", text: "dark", court: "1er sans asc." },
  etage_2_plus: { bg: "danger", court: "2e+ sans asc." },
  a_confirmer: { bg: "warning", text: "dark", court: "Manutention à confirmer" },
};

const BadgeEstimationManutention = ({ estimation, className = "" }) => {
  if (!estimation) return null;

  const style = STYLES[estimation.niveau] || STYLES.pied_camion;
  const poids = (estimation.details || []).find((d) => d.endsWith(" kg"));
  const titre = [estimation.libelle, ...(estimation.details || []), `~${estimation.minutes_prevues} min sur place prévues`]
    .join(" · ");

  return (
    <Badge bg={style.bg} text={style.text} className={className} title={titre}>
      🏋️ {style.court} · ~{estimation.minutes_prevues} min{poids ? ` · ${poids}` : ""}
    </Badge>
  );
};

export default BadgeEstimationManutention;
